import React, { useEffect } from 'react'
import {
  Typography,
  Grid,
  Box,
  Divider,
} from '@material-ui/core'
import HiringForecast from './HiringForecast'
import Dialog from '../../../../../components/Dialog'
import PropTypes from 'prop-types'

// Components
import ProjectedHeadCountDetail from './ProjectedHeadCountDetail/ProjectedHeadCountDetail'

export default function ProjectedHeadCount(props) {

	// const [openForecastDlg, setOpenForecastDlg] = useState(false)

	useEffect(() => {
		props.setOpenForecastDlg(props.openForecastDlg)
	}, [props])

	return (
		<>
			<Grid container direction='row' justify='space-between' alignItems='center'>
				<Grid item xs={6}>
					<Typography variant="h4">
						WorkForce Report
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Box mt={2}></Box>
					<Divider />
				</Grid>
				<Grid item xs={12}>
					<Box mt={2}></Box>
					<ProjectedHeadCountDetail
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['WorkforceProjectedHeadCountDetails']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['WorkforceProjectedHeadCountDetails']}
						reportData={props.reportData['WorkforceProjectedHeadCountDetails']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						forecastOptions={props.forecastOptions}
						selectedForecast={props.selectedForecasts['workforceProjectedDetails']}
						forecastSelectionChanged={props.forecastSelectionChanged}
						reportFiltersType={props.reportFiltersType['WorkforceProjectedHeadCountDetails']}
						reportDataChanged={props.reportDataChanged}
					/>
				</Grid>
			</Grid>
			<Dialog
				size={'lg'}
				title={'Create/Update Hiring Forecast'}
				isOpen={props.openForecastDlg}
				onClose={() => props.setOpenForecastDlg(false)}
			>
				<HiringForecast
					masterData={props.masterData}
					hiringForecastCreated={props.hiringForecastCreated}
					forecastOptions={props.forecastOptions}
					selectedForecast={props.forecastOptions[0]}
				/>
			</Dialog>
		</>
	)
}

ProjectedHeadCount.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.object.isRequired,
	onApply: PropTypes.func.isRequired,
	hiringForecastCreated: PropTypes.func.isRequired,
	forecastOptions: PropTypes.array.isRequired,
	selectedForecasts: PropTypes.object.isRequired,
	forecastSelectionChanged: PropTypes.func.isRequired,
}
